import { IClub } from '../clubs/store';

export const invitationStore = {
  accepted: false,
  club: {
    course: { id: 0, name: '', address: '' },
    description: '',
    email: '',
    id: 0,
    index: '0',
    managements: [],
    members: [],
    membershipPrice: '',
    name: '',
    processPayment: false
  },
  code: '',
  email: '',
  event: NaN,
  expired: false,
  id: 0,
  match: false,
  sent: ''
};

export interface IInvitationStore {
  accepted: boolean;
  club: IClub;
  code: string;
  email: string;
  expired: boolean;
  id: number;
  match: boolean;
  sent: string;
  event?: number;
}
